import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App";

import { Amplify } from "aws-amplify";
import { I18n } from "@aws-amplify/core";
import { translations } from "@aws-amplify/ui-react";
import awsconfig from "./aws-exports";

function withCurrentOriginRedirects(config) {
  if (typeof window === "undefined" || !config?.oauth) return config;

  const currentOrigin = `${window.location.origin}/`;
  const addOrigin = (value) => {
    const values = String(value || "")
      .split(",")
      .map((item) => item.trim())
      .filter(Boolean);

    if (!values.includes(currentOrigin)) {
      values.push(currentOrigin);
    }

    return values.join(",");
  };

  return {
    ...config,
    oauth: {
      ...config.oauth,
      redirectSignIn: addOrigin(config.oauth.redirectSignIn),
      redirectSignOut: addOrigin(config.oauth.redirectSignOut),
    },
  };
}

// 1. Configura o Amplify
Amplify.configure(withCurrentOriginRedirects(awsconfig));

// 2. Traduções em português para Amplify UI/messages
const customTranslations = {
  pt: {
    "Sign in": "Entrar",
    "Sign In": "Entrar",
    "Sign up": "Cadastrar",
    "Username": "Nome de usuário",
    "Password": "Senha",
    "Forgot your password?": "Esqueceu sua senha?",
    "Email": "Email",
    "Phone Number": "Número de Telefone",
    "Create Account": "Criar Conta",
    "Confirm a Code": "Confirmar Código",
    "Confirm Account": "Confirmar Conta",
    "User does not exist.": "Usuário não existe.",
    "Incorrect username or password.": "Usuário ou senha incorretos.",
    "User is not confirmed.": "Usuário não está confirmado.",
    "A verification code has been sent to your email.": "Um código de verificação foi enviado para o seu email.",
    "Please enter your username.": "Por favor, insira seu nome de usuário.",
    "Your code is incorrect or expired.": "Seu código está incorreto ou expirou.",
    "Name": "Nome",
    "Confirm Password": "Confirmar Senha",
    "Enter your Email": "Digite seu e-mail",
    "Enter your Password": "Digite sua senha",
    "Enter your email": "Vamos te ajudar. Informe seu e‑mail:",
    "Send code": "Enviar Código",
    "Back to Sign In": "Voltar para o Login",
    "Reset Password": "Esqueceu sua senha?",
    "Please confirm your Password": "Por Favor, confirme sua senha",
    "Enter your Name": "Digite seu nome",
    "Code": "Código",
    "Code *": "Digite o código",
    "New Password": "Nova Senha",
    "Submit": "Enviar",
    "Resend Code": "Reenviar Código",
    "Sending": "Enviando",
    "Password must have at least 8 characters": "A senha deve ter no mínimo 8 caracteres",
    "Your passwords must match": "As senhas devem coincidir",
    "Invalid verification code provided, please try again.": "Código de verificação inválido. Tente novamente.",
    "Attempt limit exceeded, please try after some time.": "Limite de tentativas excedido. Tente novamente mais tarde.",
    "Signing in": "Entrando",
    "Password attempts exceeded": "Número de tentativas de senha excedido",
    "User already exists": "Usuário já existe",
    "Sign in with Google": "Entrar com Google",
    "Confirm": "Confirmar",
    "Confirmation Code": "Código de confirmação",
    "Enter your code": "Digite seu código",
    "Your code is on the way. To log in, enter the code we emailed to {username}. It may take a minute to arrive.": "Seu código está a caminho. Para fazer login, digite o código que enviamos para {username}. Pode levar alguns minutos para chegar.",
    "Confirming": "Confirmando",
    "Exceed max confirmation code attempts. Please resend confirmation code and retry.": "Número máximo de tentativas de código de confirmação excedido. Por favor, reenvie o código e tente novamente."
  },
};

// 3. Registra as traduções
I18n.putVocabularies(translations); // Carrega as traduções padrão do Amplify
I18n.putVocabulariesForLanguage("pt", customTranslations.pt); // Sobrescreve com as suas traduções

// 4. Define o idioma padrão para português
I18n.setLanguage("pt");

// 5. Renderiza o React normalmente
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
